import React, { Component } from 'react';
import axios from 'axios';
import '../../Asset/Css/Site.css';
import 'react-notifications-component/dist/theme.css'
import { Card, Row, Col, InputGroup, FormControl, Modal, Button } from 'react-bootstrap';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { config } from '../../Constants';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component';
import global from '../global';
import Spinner from '../Spinner';
import EasyDividendLogo from '../../Asset/Images/easy-dividend-logo.png';
import goBack from '../../Asset/Images/previous-icon.png';

export class ResetPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isVerified: false,
            DPID: '',
            PAN: '',
            Email: '',
            OTP: '',
            Password: '',
            ConfirmPassword: '',
            showValidatePassword: 'none',
            showResetPassword: 'none',
            showValidateOTP: 'none',
            showEmail: 'block',
            showTiming: 'none',
            showReOTP: 'none',
            time: {},
            seconds: 600,
            loading: false,
            URL: config.url.Web_URL
        };
        this.initialState = this.state;

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleValidate = this.handleValidate.bind(this);
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }

    closeModal = () => {
        this.setState({ isOpen: false })

        window.location.href = config.url.Web_URL + '/SignIn';
    };

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    startTimer() {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds == 0) {
            clearInterval(this.timer);
            this.setState({ showReOTP: 'block', showTiming: 'none' });
        }
    }

    showNoti(title, message, type) {
        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });
    };

    handleSubmit = (e) => {
        debugger

        if (this.state.Email == "" || this.state.Email == null) {
            this.showNoti("Notification", "Email is required.", "danger");
            return;
        }

        if (this.state.Email !== "") {
            var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

            if (!regex.test(this.state.Email)) {
                this.showNoti("Notification", "Invalid Email Address.", "danger");
                return;
            }
        }

        const sendOTPEmail = this.state;

        axios.post(global.UserManagement.SendResetOTP, sendOTPEmail)
            .then(json => {
                if (json.data.status) {
                    this.setState({
                        showValidateOTP: 'block',
                        showEmail:'none'
                    });
                                  
                    this.showNoti("Notification", "OTP sent successfully; check on your entered email.", "success");
                    this.timer = setInterval(this.countDown, 1000);
                    this.setState({ showReOTP: 'none', showTiming: 'block', time: {}, seconds: 600 });  
                }
                else {
                    this.showNoti("Notification", json.data.message, "danger");

                }
            })

    }

    handleChange(e) {
        debugger
        const { name, value } = e.target;

        this.setState({ [name]: value });

    }

    handleValidate(e) {
        debugger

        if (this.state.OTP == '') {
            this.showNoti("Notification", "Please enter OTP.", "danger");
            return;
        }

        if (isNaN(this.state.OTP)) {
            this.showNoti("Notification", "Invalid OTP.", "danger");
            return;
        }

        const OTP = this.state;
        axios.post(global.UserManagement.ValidateResetOTPNew, OTP)
            .then(json => {
                if (json.data.status) {

                    this.setState({
                        showValidateOTP: 'none',
                        showValidatePassword: 'block',
                        showResetPassword: 'none',
                        showEmail: 'none',
                        showReOTP: 'none',
                        showTiming:'none'

                    });
                    this.showNoti("Notification", "OTP validated successfully.", "success");


                    //this.setState({ isOpen: true });
                }
                else {
                    this.showNoti("Notification", json.data.message, "danger");
                }
            });

    }

    handleReset = (e) => {
        debugger

        if (this.state.Password == "" || this.state.Password == null) {
            this.showNoti("Notification", "Password is required.", "danger");
            return;
        }

        if (this.state.Password.length < 8) {
            this.showNoti("Notification", "Your password must be at least 8 characters", "danger");
            return;
        }

        if (this.state.Password.search(/[a-z]/i) < 0) {
            this.showNoti("Notification", "Your password must contain at least one letter.", "danger");
            return;
        }

        if (this.state.Password.search(/[0-9]/) < 0) {
            this.showNoti("Notification", "Your password must contain at least one digit.", "danger");
            return;
        }
        if (this.state.Password.search(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/) < 0) {
            this.showNoti("Notification", "Your password must contain at least one special character.", "danger");
            return;
        }
        if (this.state.ConfirmPassword == "" || this.state.ConfirmPassword == null) {
            this.showNoti("Notification", "Confirm Password is required.", "danger");
            return;
        }

        if (this.state.Password != this.state.ConfirmPassword) {
            this.showNoti("Notification", "Password & Confirm Password should match.", "danger");
            return;
        }

        

        const OTP = this.state;
        axios.post(global.UserManagement.ResetPasswordNew, OTP)
            .then(json => {
                if (json.data.status) {
                    this.setState({ isOpen: true });
                }
                else {
                    this.showNoti("Notification", json.data.message, "danger");
                }
            });
    }

    handleCancel = (e) => {
        e.preventDefault();
        window.location.href = config.url.Web_URL;
    }

    render() {

        return (
            <div>
                <ReactNotification />

                <div className="main-bg">
                    <img src={EasyDividendLogo} alt="Logo" className="logo-img" />
                    <div className="sub-main-w3">
                        <div className="image-style">

                        </div>

                        <div className="vertical-tab">
                            <a href={this.state.URL + "/SignIn"} className="section-w3ls">
                                <input type="radio" name="sections" onClick={this.state.URL + "/SignIn"} />
                                <label className="icon-left-w3pvt"><span className="fa fa-user-circle" aria-hidden="true"></span>Login</label>
                            </a>
                            <a href={this.state.URL + "/SignUp"} className="section-w3ls">
                                <input type="radio" name="sections" onClick={this.state.URL + "/SignUp"} />
                                <label className="icon-left-w3pvt"><span className="fa fa-pencil-square" aria-hidden="true"></span>Sign Up</label>
                            </a>
                            <div className="section-w3ls">
                                <input type="radio" name="sections" id="option3" onClick={this.state.URL + "/ResetPassword"} checked />
                                <label for="option3" className="icon-left-w3pvt">
                                    <span className="fa fa-lock" aria-hidden="true"></span>
                                    
                                    Forgot Password?
                                </label>
                               
                                <article>
                                    <div className="form h-430">
                                        <h3 className="legend last">Reset Password</h3>
                                        <p className="para-style m-t-20">Enter your email address below and then an OTP will be sent to your email to reset your password. If you don't get an email within a few minutes, please re-try.</p>

                                        <div>
                                            <label className="required-field m-t-20">Email</label>
                                            <FormControl type="email" name="Email" key="txtEmail" className="m-t-10"
                                                value={this.state.Email}
                                                onChange={this.handleChange}
                                                placeholder="Max 100 Characters"
                                                maxLength="100"
                                                autoCompleteto="new-password"
                                            />
                                        </div>

                                        <div style={{ display: `${this.state.showEmail}` }}>
                                            <button type="submit" onClick={this.handleSubmit} className="btn submit last-btn m-t-20">Submit</button>
                                        </div>

                                        <div style={{ display: `${this.state.showValidateOTP}` }}>
                                            <div className="form-group m-form__group">
                                                <label className="required-field m-t-20">OTP</label>
                                                <FormControl type="text" name="OTP" className="m-t-10"
                                                    value={this.state.OTP}
                                                    onChange={this.handleChange}
                                                    placeholder="Format: 123456"
                                                    maxLength="6"
                                                    autoCompleteto="new-password"
                                                />
                                            </div>
                                            <div className="m-login__form-action">
                                                <button type="button" onClick={this.handleValidate} className="btn submit last-btn" >
                                                    VALIDATE OTP
                                            </button>
                                            </div>
                                        </div>

                                        <div className="m-t-20" style={{ display: `${this.state.showTiming}` }}>
                                            <button> Time Remaining: {this.state.time.m} : {this.state.time.s}  </button>
                                        </div>
                                        <div className="m-t-20" style={{ display: `${this.state.showReOTP}` }}>
                                            <button onClick={this.handleSubmit}> Click Here to Re-Generate OTP  </button>
                                        </div>

                                        <div style={{ display: `${this.state.showValidatePassword}` }}>
                                            <div className="form-group m-form__group">
                                                <Row>
                                                    <Col md={6} style={{ display: `${this.state.showRegisterDetails}` }}>
                                                        <label className="required-field">Password</label>
                                                        <FormControl type="password" name="Password" className="m-t-10" maxLength="100"
                                                            value={this.state.Password}
                                                            onChange={this.handleChange}
                                                            placeholder="Max 50 Characters"
                                                            autoCompleteto="off"
                                                        />
                                                    </Col>
                                                    <Col md={6} style={{ display: `${this.state.showRegisterDetails}` }}>
                                                        <label className="required-field">Confirm Password</label>
                                                        <FormControl type="password" name="ConfirmPassword" className="m-t-10" maxLength="50"
                                                            value={this.state.ConfirmPassword}
                                                            onChange={this.handleChange}
                                                            placeholder="Max 50 Characters"
                                                            autoCompleteto="off"
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
              
                                            <div className="m-login__form-action">
                                                <button type="button" onClick={this.handleReset} className="btn submit last-btn" >
                                                    Reset Password
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </article>

                                <Row>
                                    <Modal show={this.state.isOpen} onHide={this.closeModal}>
                                        <Modal.Header closeButton>
                                            <Modal.Title className="modal_title">Notification</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body className="modal_body">
                                            Password Reset Successfully. Kindly Login using new password.
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="dark" onClick={this.closeModal}>
                                                Close
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>

                                </Row>

                            </div>
                        </div>
                        <div className="clear"></div>
                        <img src={goBack} class="go_back" onClick={this.handleCancel} alt="Go to previous page" title="Go to previous page" />

                    </div>
                </div>
            </div>
        );
    }
}